import * as requestFromServer from "./serviceProviderUserChatApis";
import Actions from "../../actions";
import { toastService } from "../../../component/common/toast-messages/toast";

// service provider user chat -> get service provider user chat api
export const getServiceProviderUserChatAction =
  (dataToBeSent, setLoading, userSession) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderUserChat(dataToBeSent);
    if (response) {
      dispatch(
        Actions.createAction(Actions.GET_SERVICE_PROVIDER_USER_CHAT_LIST, {
          serviceProviderUserChat: response,
          userSession
        })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider user chat -> get service provider user chat request api
export const getServiceProviderUserChatRequestAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getServiceProviderUserChatRequest(
      dataToBeSent
    );
    if (response) {
      dispatch(
        Actions.createAction(
          Actions.GET_SERVICE_PROVIDER_USER_CHAT_REUQEST_LIST,
          { serviceProviderUserChatRequest: response }
        )
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider user chat -> get service provider user chat details by id api
export const getServiceProviderUserChatDetailsByIdAction =
  (setLoading, dataToBeSent) => async (dispatch) => {
    setLoading(true);
    const response =
      await requestFromServer.getServiceProviderUserChatDetailsById(
        dataToBeSent
      );
    if (response) {
      dispatch(
        Actions.createAction(
          Actions.GET_SERVICE_PROVIDER_USER_CHAT_DETAILS_BY_ID,
          { serviceProviderUserChatDetailsById: response }
        )
      );
      dispatch(
        Actions.createAction(Actions.GET_SERVICE_PROVIDER_USER_CHAT_MESSAGES, {
          serviceProviderUserChatMessages: response,
        })
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider user chat -> send service provider user chat api
export const sendUserChatMessageAction =
  (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.sendUserChatMessage(dataToBeSent);
    if (response) {
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider user request chat by id
export const getServiceProviderRequestChatById =
  (setLoading, dataToBeSent) => async (dispatch) => {
    setLoading(true);
    const response =
      await requestFromServer.getServiceProviderRequestChatDetailsById(
        dataToBeSent
      );
    if (response) {
      dispatch(Actions.createAction(Actions.GET_SERVICE_PROVIDER_REQUEST_DETAILS_BY_ID,{response:response, user: dataToBeSent?.user,chat_post:response?.chat_post_id})
      );
      setLoading(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };

// service provider user request update status
export const updateRequestStatusAction =
  (dataToBeSent, setLoading, setOpen) => async (dispatch) => {
    setLoading(true);
    const response =
      await requestFromServer.updateRequestStatus(dataToBeSent);
    if (response) {
      toastService.success(response?.message);
      setLoading(false);
      setOpen(false);
      return response;
    } else {
      setLoading(false);
      return null;
    }
  };
